module.exports = __webpack_public_path__ + "static/img/休眠.998ea22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/随车吊/休眠.png
// module id = Cm56
// module chunks = 76